var map = {
	"./alimentacion.svg": 4433,
	"./colaciones.png": 9965,
	"./compromiso.png": 6813,
	"./cuidado.png": 2450,
	"./emprendimiento.png": 9037,
	"./innovacion.png": 2385,
	"./lavanderia.svg": 9916,
	"./left_arrow.svg": 6241,
	"./limpieza.png": 2690,
	"./right_arrow.svg": 3581
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;